import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installMobileInputScrollGuard } from "./utils/mobileViewportShell";
import { redactCredentials } from "./utils/redactCredentials";
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { BrowserRouter } from "react-router-dom";
import store from "./App/store";
import { Provider } from "react-redux";
import { AuthProvider } from "./context/AuthContext";
import { GlobalProvider } from "./context/GlobalContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { PostHogProvider} from 'posthog-js/react';

console.log("[MagicFurnish] REACT_APP_ENV:", process.env.REACT_APP_ENV);

installMobileInputScrollGuard();

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  disable: process.env.NODE_ENV === 'development' || !process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
  session_recording: {
    maskCapturedNetworkRequestFn: (request) => {
        request.requestBody = redactCredentials(request.requestBody)
        request.responseBody = redactCredentials(request.responseBody)
        return request
    }
}
}

const AppContent = () => (
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Provider store={store}>
        <GlobalProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </GlobalProvider>
      </Provider>
    </BrowserRouter>
  </GoogleOAuthProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  process.env.NODE_ENV === 'production' && process.env.REACT_APP_PUBLIC_POSTHOG_KEY ? (
    <PostHogProvider 
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <AppContent />
    </PostHogProvider>
  ) : (
    <AppContent />
  )
);
